import { render, staticRenderFns } from "./chemGhs.vue?vue&type=template&id=6bb05342"
import script from "./chemGhs.vue?vue&type=script&lang=js"
export * from "./chemGhs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb05342')) {
      api.createRecord('6bb05342', component.options)
    } else {
      api.reload('6bb05342', component.options)
    }
    module.hot.accept("./chemGhs.vue?vue&type=template&id=6bb05342", function () {
      api.rerender('6bb05342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemGhs.vue"
export default component.exports